import { Injectable } from "@angular/core";
import { Observable, of as observableOf } from "rxjs";
import { map, catchError } from "rxjs/operators";

import { SaleModel } from "../../shared/entities/sale.model";
import { ClientModel } from "../../shared/entities/client.model";
import { SalesService } from "../services/sales/sales.service";

@Injectable()
export class SaleModelRepository {
	constructor(private service: SalesService) {}

	public getAdminSales(client?: string): Observable<SaleModel[]> {
		return this.service.getSales(client).pipe(
			map((data: { data: SaleModel[] }) => data.data),
			catchError((err) => observableOf(err)),
		);
	}

	public getClientBySaleId(id: string): Observable<ClientModel> {
		return this.service.getClientBySaleId(id).pipe(
			map((data: ClientModel) => {
				const clientModel: ClientModel = new ClientModel().deserialize(data);
				return clientModel;
			}),
			catchError((err) => observableOf(err)),
		);
	}

	public getSaleByOrderId(orderId: string): Observable<SaleModel> {
		return this.service.getSaleByOrderId(orderId);
	}

	public updateSaleModelById(model: SaleModel, body: any): Observable<SaleModel | null> {
		return this.service.patchSaleModelById(model, body).pipe(
			map((data: SaleModel) => {
				const saleModelAux: SaleModel = new SaleModel().deserialize(data);
				return saleModelAux;
			}),
			catchError(() => {
				return observableOf(null);
			}),
		);
	}
}
